<template>
  <div :class="[classBase + 'wiki-list']" class="list-page">
    <fixed-share />
    <wiki-home-top />
    <div class="list-detail-box">
      <!-- 右侧悬浮按钮 -->
      <right-banner :gameInfo="gameInfo" />
      <div class="list-container">
        <!-- 顶部搜索 -->
        <div>
          <!-- 搜索栏 -->
          <div class="search-top-line">
            <input v-model="keyword" type="text" class="search-input" @keyup.enter="onSearch" />
            <el-button type="primary" class="search-btn" @click="onSearch">搜索</el-button>
          </div>
          <!-- 标签检索栏 -->
          <div class="list-nav-box">
            <div class="list-nav">
              <div
                v-for="(item, index) in typeActive"
                :key="index"
                :class="activeType === item.type ? 'active' : ''"
                class="list-nav-a"
                @click="handleBtn(item.type)"
              >
                {{ item.name }}<i></i>
              </div>
            </div>
            <!-- 默认列表排序 -->
            <el-dropdown @command="onChange">
              <el-button class="el-dropdown-link">
                {{ orderList[order_by] || "默认排序" }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, key) in orderList" :key="key" :command="key">{{
                  item
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- 列表 -->
        <div class="wiki-list">
          <div class="wiki-list-content">
            <!-- 公告 -->
            <model-container v-show="activeType != '2'" class="notice-list">
              <notice-list-group :list="topList" />
            </model-container>
            <!-- 滚动列表 -->
            <div class="list-content">
              <scroll-comp ref="scrollComp" :page-load="getAllList">
                <template v-if="activeType != '2'">
                  <article-list-item
                    v-for="item in list"
                    :key="item.id"
                    :item="item"
                    :keyword="isSearch ? keyword : ''"
                    layout="column"
                  />
                </template>
                <template v-else>
                  <notice-list-group :all="true" :list="list" />
                </template>
              </scroll-comp>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部发帖区域 -->
    <!-- <div id="footer-edit" :class="['footer-edit', isScroll ? 'hidden-footer' : '']">
      <send-article-box
        v-if="needLogin"
        style="width: 1000px"
        :customStyle="{ height: '50px' }"
        ref="sendBox"
        :onOk="onSendBoxOk"
        :placeholder="loginUid > 0 ? '友善发帖，文明交流' : $t('login_to_post')"
      />
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// components
import ArticleListItem from "./components/articleListItem";
import ScrollComp from "@/components/Scroll";
import NoticeListGroup from "@/views/wiki/components/noticeListGroup";
import ModelContainer from "@/views/wiki/components/modelContainer";
import WikiHomeTop from "@/views/wiki/components/wikiHomeTop";
import FixedShare from "@/views/wiki/components/fixedShare";
import RightBanner from "@/views/wiki/components/rightBanner";
// plugins
import eventBus from "@/plugins/eventBus";
// api
import { apiContentList, apiContentTopList, apiContentEdit } from "@/api/contentApi";
// mixins
import mergeAsyncDataMixin from "@/mixins/mergeAsyncDataMixin";

export default {
  name: "wikiList",
  mixins: [mergeAsyncDataMixin],
  props: {},
  model: {},
  components: {
    ModelContainer,
    NoticeListGroup,
    ScrollComp,
    ArticleListItem,
    WikiHomeTop,
    FixedShare,
    RightBanner
  },
  data() {
    return {
      typeActive: [
        {
          type: "4",
          name: this.$t("posts")
        },
        {
          type: "15",
          name: this.$t("strategy")
        },
        {
          type: "2",
          name: this.$t("notices")
        },
        {
          type: "1",
          name: this.$t("entrys")
        },
        {
          type: "17",
          name: this.$t("question")
        },
        {
          type: "",
          name: this.$t("all")
        }
      ],
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      activeType: "4", // 默认取帖子类型
      keyword: "",
      order_by: "",
      orderList: {
        created_at: "最新发帖",
        updated_at: "最近更新",
        comment_at: "最新回复",
        default: "默认排序"
      },
      isSearch: false,
      list: [],
      topList: [],
      isSSRGetData: false,
      isScroll: false,
      timer: null
    };
  },
  async asyncData({ store, router, ssrContext, $apis }) {
    try {
      console.log("asyncData start");
      // TDK设置
      const gameInfo = store.getters.gameInfo;
      ssrContext.title = `${gameInfo.name}论坛社区_${gameInfo.name}wiki|GameKee`;
      ssrContext.keywords = `${gameInfo.name}论坛,${gameInfo.name}社区`;
      ssrContext.description = `${gameInfo.name}wiki的${gameInfo.name}论坛版块为${gameInfo.name}玩家们提供互相交流的平台，快来加入${gameInfo.name}社区吧！`;
      // 数据预取
      const { query } = router.currentRoute;
      const activeType = query.tab || "4"; // 默认帖子
      const params1 = {
        limit: 3,
        type: "2"
      };
      let pagination = {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      };
      const params2 = {
        ...pagination,
        type: activeType,
        order_by: "",
        keyword: ""
      };
      const resList = await Promise.all([$apis.apiContentList(params1), $apis.apiContentTopList(params2)]);

      let topList = [];
      if (resList[0].code == 0 && resList[0].data) {
        topList = resList[0].data;
      }
      let list = [];

      if (resList[1].code == 0) {
        list = resList[1].data;
        pagination = resList[1].meta.pagination;
      }
      console.log("asyncData end");
      // console.log(list)
      return {
        topList,
        list,
        pagination,
        isSSRGetData: true
      };
    } catch (err) {
      console.log(err);
    }
  },
  computed: {
    ...mapGetters(["loginUser", "gameInfo"])
  },
  methods: {
    onChange(command) {
      console.log(command);
      this.order_by = command == "default" ? "" : command;
      this.reset();
    },
    goEditor(type) {
      if (!this.isLoginShow()) return false;
      if (!this.isAuthRealName()) return false;
      if (type == 1) {
        this.$router.push("/editor");
      } else {
        this.$router.push("/wap-editor");
      }
    },
    // 切换分类，清空滚动状态
    handleBtn(type) {
      this.activeType = type;
      console.log(type);
      this.reset();
    },
    getAllList() {
      let { pagination, $refs, activeType } = this;
      if (!["wikiList", "noWikiList"].includes(this.$route.name)) return;
      // 达到最大页数后，不触发翻页方法；
      if (pagination.page_no >= pagination.page_total) {
        $refs.scrollComp.loadStatus = "end";
        return;
      }
      ++pagination.page_no;
      if (activeType == "2") {
        pagination.limit = 20;
      }
      const params = {
        ...pagination,
        type: activeType,
        order_by: this.order_by
      };
      if (this.keyword) {
        params.keyword = this.keyword;
      }
      $refs.scrollComp.loadStatus = "loading";
      apiContentTopList(params)
        .then(res => {
          if (res.code == 0) {
            this.list = this.list.concat(res.data || []);
            this.pagination = res.meta.pagination;
          }
        })
        .finally(_ => {
          $refs.scrollComp.loadStatus = "";
        });
    },
    onSendBoxOk(data) {
      if (!this.isLoginShow("")) return false;
      if (!this.isAuthRealName("")) return false;
      console.log(data);
      const { text, thumb, contentJson } = data;

      let params = {
        editor_type: 1, // 新编辑器
        content_json: JSON.stringify(contentJson),
        summary: text.slice(0, 100),
        title: "",
        type: 4,
        thumb: thumb.join(",")
      };

      apiContentEdit(params).then(res => {
        this.$message.success("发布成功");
        params = {
          ...params,
          game: this.gameInfo,
          game_alias: this.gameInfo.alias,
          game_id: this.gameInfo.id,
          like_count: 0,
          id: res.data.id,
          comment_count: 0,
          view_count: 0,
          user: this.loginUser,
          updated_at: 0
        };
        const insertIndex = this.list.findLastIndex(item => {
          return item.is_top;
        });
        this.list.splice(insertIndex + 1, 0, params);
        this.$refs.sendBox.onClear();
      });
    },
    getTopList() {
      this.loading = true;
      const params = {
        limit: 3,
        type: "2"
      };
      apiContentList(params)
        .then(res => {
          if (res.code == 0) {
            this.topList = res.data || [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onWapSearch(data) {
      this.keyword = data.kw;
      if (data.kw || !data.isSearch) {
        this.reset();
      }
    },
    onSearch() {
      if (this.keyword) {
        this.isSearch = true;
      } else {
        this.isSearch = false;
      }

      this.reset();
    },
    setSearchKw() {
      this.keyword = this.$route.query.kw || "";
      if (!this.keyword && this.list.length > 0) return;
      this.list = [];
      if (!this.list.length) {
        this.reset();
      }
    },
    // 重置分页状态等
    reset() {
      this.pagination = {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      };
      this.$refs.scrollComp.loadStatus = "";
      this.list = [];
      this.getAllList();
    },
    handleScroll() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (!this.isScroll) {
        this.isScroll = true;
      }
      this.timer = setTimeout(() => {
        this.isScroll = false;
      }, 100);
    }
  },
  watch: {},
  created() {},
  mounted() {
    // 判断服务端是否获取数据
    if (!this.isSSRGetData) {
      this.getTopList();
    }
    eventBus.$on("onWapSearch", this.onWapSearch);
    window.addEventListener("scroll", this.handleScroll);
  },
  activated() {
    this.activeType = this.$route.query.tab || "4"; // 默认帖子类型
    this.setSearchKw();
  },
  updated() {},
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  destroyed() {}
};
</script>

<style lang="less" scoped>
.wiki-list {
  display: flex;
  align-items: flex-start;
  position: relative;
  width: 100%;

  .wiki-list-content {
    width: 100%;
    min-height: 500px;
    border-radius: 6px;
    margin-bottom: 20px;
  }

  .list-search {
    width: 330px;
    height: auto;
    background-color: #fff;
    margin-left: 8px;
    padding: 18px;

    .list-search-box {
      width: 300px;
      height: 40px;
      background-color: #f2f2f2;
      border-radius: 19px;
      position: relative;

      input {
        width: 100%;
        height: 100%;
        line-height: 40px;
        text-indent: 20px;
        outline: none;
        border: 0;
        background: none;
      }

      .iconfont {
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 20px;
        color: @text-basic;
      }
    }

    .send-btn {
      width: 100%;
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .iconfont {
        font-size: 16px;
        margin-right: 4px;
      }
    }
  }
}

.pc-wiki-list {
  .wiki-list-content {
    // width: calc(100% - (330px + 8px));

    .list-important {
      background: #fff;
      padding: 15px 25px;
      margin-bottom: 14px;
      border-radius: 6px;

      a {
        display: block;
        width: 100%;
        overflow: hidden;
        font-size: 14px;
        color: #151515;
        line-height: 44px;
        text-overflow: ellipsis;
        white-space: nowrap;

        em {
          font-size: 1px;
          line-height: 14px;
          padding: 2px 2px;
          font-style: normal;
          margin-right: 5px;

          &.gg {
            color: #ffa42e;
            border: 1px solid #ffa42e;
          }

          &.new {
            color: #fc6475;
            border: 1px solid #fc6475;
          }

          &.act {
            color: #00cb1e;
            border: 1px solid #00cb1e;
          }
        }

        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .list-content {
      background: #fff;
      margin-top: 32px;
    }
  }

  .list-nav-box {
    padding: 18px 0;
    margin-bottom: 24px;
  }

  .list-nav {
    display: flex;

    .list-nav-a {
      font-size: 14px;
      color: #1a1a1a;
      border: 1px solid transparent;
      position: relative;
      margin-right: 64px;
      cursor: pointer;
      display: flex;
      align-items: center;

      i {
        display: none;
        width: 24px;
        height: 4px;
        border-radius: 4px;
        background: #07b2fd;
        position: absolute;
        left: 50%;
        bottom: -14px;
        margin-left: -12px;
      }

      &.active {
        color: #00afe8;
        font-weight: 500;

        i {
          display: block;
        }
      }

      &.mar {
        margin: 0 52px;
      }
    }
  }

  .notice-list {
    margin: 0;
  }
}

.wap-wiki-list {
  .wiki-list-content {
    width: 100%;
  }

  .list-nav-box {
    margin-top: 4px;
    background: #fff;
    border-bottom: 1px solid @border-basic;
  }

  .list-nav {
    display: flex;
    align-items: stretch;
    padding: 0 14px;
    line-height: 34px;

    .list-nav-a {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #868686;
      font-size: 13px;
      border-bottom: 2px solid transparent;
      box-sizing: border-box;

      & + .list-nav-a {
        margin-left: 25px;
      }

      &.active {
        color: #000;
        font-weight: 500;
        position: relative;

        &:after {
          content: "";
          width: 20px;
          height: 2px;
          border-radius: 2px;
          background: #000;
          position: absolute;
          bottom: -2px;
          left: 50%;
          transform: translateX(-10px);
        }
      }
    }
  }

  .notice-list {
    margin: 0;
  }

  .list-content {
    background: #fff;
    padding: 0;
  }
}

.wap-send-btn {
  position: fixed;
  bottom: 60px;
  right: 40px;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: @text-basic;
  border: none;
  color: @text-primary;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 5px @text-primary;

  .iconfont {
    font-size: 20px;
  }
}
.footer-edit {
  z-index: 10;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  left: 50%;
  width: 1360px;
  min-height: 150px;
  transform: translateX(-50%);
  background-color: #fff;
  transition: all ease 0.3s;
  &.hidden-footer {
    bottom: -100%;
  }
}

.list-page {
  width: 100%;
  margin: auto;
  .list-detail-box {
    position: relative;
    width: 100%;
    margin-top: 12px;
    padding: 12px 10px;
    background: rgba(174, 181, 203, 0.45);
    border-radius: 12px;
    .list-container {
      width: 100%;
      padding: 40px 205px;
      box-sizing: border-box;
      background-color: #fff;
      .search-top-line {
        display: flex;
        align-items: center;
        width: 100%;
        .search-input {
          flex: 1;
          height: 40px;
          padding: 0 6px;
          outline: none;
          border: none;
          box-sizing: border-box;
          color: #8b8b8b;
          border-radius: 4px;
          background-color: #efefef;
        }
        .search-btn {
          flex: 0 0 auto;
          height: 40px;
          width: 155px;
          margin-left: 16px;
        }
      }
    }
  }
}

.list-nav-box {
  display: flex;
  align-items: center;
  justify-content: space-between;

  /deep/ .el-dropdown {
    margin-right: 16px;
    font-size: 13px;
  }
}
</style>
